<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="tips"
      @load="getList"
    >
      <div v-for="(item,index) in list" :key="index" class="data">
        <div class="hd">
          <div v-if="item.adviceType==='MOTION'">运动建议</div>
          <div v-if="item.adviceType==='DIET'">饮食建议</div>
          <div v-if="item.adviceType==='PHYSICAL'">理疗建议</div>
          <div v-if="item.adviceType==='OTHER'">其他建议</div>
          <div class="time">{{ dateFormat(item.createTime, 'YY-MM-DD hh:mm') }}</div>
        </div>
        <div class="bd">
          {{ item.adviceContent }}
        </div>
      </div>
    </van-list>

  </div>
</template>

<script>
import { dateFormat } from '@/utils/tool'
import { fetchSuggest, updateRead } from '@/api/health'
import { getAccountId } from '@/utils/auth'
export default {
  data() {
    return {
      dateFormat,
      tips: '',
      loading: false,
      finished: false,
      list: [],
      accountId: getAccountId(),
      listQuery: {
        page: 1,
        row: 20
      }
    }
  },
  created() {
    this.updateRead()
  },
  methods: {
    getList() {
      fetchSuggest(this.listQuery).then(res => {
        this.loading = false
        var list = res.data.data
        if (list === null || list === '') {
          list = []
        }
        if (this.listQuery.page === 1) {
          this.list = list
        } else {
          this.list = this.list.concat(list)
        }
        this.listQuery.page++
        this.finished = list.length < 20
        this.tips = this.list.length ? this.$t('viewBase.a46') : this.$t('viewBase.a47')
      })
    },
    updateRead() {
      updateRead({ accountId: this.accountId }).then(res => {

      })
    }

  }
}
</script>

<style scoped lang="scss">
  .data {
      background: #fff;
      margin-top: 10px;
      padding: 12px 15px;
  }
  .hd {
      display: flex;
      justify-content: space-between;
      .time {
          color: #999;
          font-size: 12px;
      }
  }
  .bd {
      color: #666;
      margin-top: 5px;
  }

</style>
